import "./dropdown-with-advanced-search.component.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";

import InputWithIconButton from "../InputWithIconButton";

const DropdownWithAdvancedSearch = props => {
  const {
    type,
    value,
    buttonIcon,
    dataBsToggleOnInput, // for toggling dropdown once clicking on input.
    dataBsToggleOnButton, // for toggling dropdown once clicking on button.
    onChange,
    onClick,
    onKeyDown,
    onFocus,
    onBlur,
    buttonOnClick,
    subContainerOnClick,
    disabled,
    alignEnd,
    dropdownMenuStyle,
    children,
    readOnly
  } = props;
  const { t } = useTranslation();
  const alignEndClassName = !!alignEnd ? 'dropdown-menu-end' : 'dropdown-menu-start';

  return (
    <div className='dropdown-advanced-search-container'>
      <InputWithIconButton
        type={type || 'text'}
        placeholder={t('13348442cc')}
        value={value}
        buttonIcon={buttonIcon}
        dataBsToggleOnInput={dataBsToggleOnInput}
        dataBsToggleOnButton={dataBsToggleOnButton}
        disabled={disabled}
        readOnly={!!readOnly}
        onChange={onChange}
        onClick={onClick}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        buttonOnClick={buttonOnClick}
      >
        <ul
          style={dropdownMenuStyle}
          className={`dropdown-menu dropdown-sub-container ${alignEndClassName}`}
          onClick={subContainerOnClick}
        >
          {children}
        </ul>
      </InputWithIconButton>


    </div>
  );
};

export default memo(DropdownWithAdvancedSearch);
